/**
 * The one audio engine the app shares (Phase 8): the menu music, the interface sounds and every
 * match play through it, so the gesture unlock and the volume settings apply once.
 */
import { AUDIO_BANK } from '@steelwake/shared/data';
import { setUiSoundHandler } from '@steelwake/ui';
import { useEffect } from 'react';

import { useSettingsStore } from '../settings/store.js';
import { AudioEngine } from './engine.js';

export const audio = new AudioEngine();

let installed = false;

/** Arms the gesture unlock, the interface sounds and the settings sync. Idempotent. */
export function installAudio(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  audio.installUnlock(window);
  setUiSoundHandler((sound) => {
    audio.play(`ui.${sound}`, { position: null });
  });
  const apply = (): void => {
    const s = useSettingsStore.getState().settings;
    audio.setLevels(s.audio);
    audio.captions = s.accessibility.captions;
  };
  apply();
  useSettingsStore.subscribe(apply);
}

/** Plays the menu bed while the site shell is mounted; the match takes the music over. */
export function useMenuMusic(): void {
  useEffect(() => {
    let cancelled = false;
    void audio.whenUnlocked().then(async () => {
      if (cancelled) return;
      await audio.library.prefetch([AUDIO_BANK.music.menu]);
      if (!cancelled) audio.playMusic(AUDIO_BANK.music.menu);
    });
    return () => {
      cancelled = true;
    };
  }, []);
}
